import { COLORS } from '../../../../../../constants/colors';
import { colors } from '@mui/material';

export const useStyles = () => ({
  root: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'black',
    zIndex: 10000,
    borderRadius: '16px',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.5)',
    overflow: 'hidden',
    '&:hover .close-button': {
      opacity: 1,
    },
    '&:hover .user-name': {
      opacity: 1,
    },
  },
  notExpandedRoot: {
    zIndex: -100,
    width: '1px',
    height: '1px',
    position: 'fixed',
  },
  userName: {
    color: COLORS.TOOLS_LIGHT_BLUE,
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    fontFamily: '"Noto Sans", sans-serif',
    opacity: 0,
    transition: 'opacity 0.3s',
    top: 16,
    left: 16,
    zIndex: 10001,
    position: 'absolute',
    paddingInline: 1,
    paddingBlock: 0.5,
    borderRadius: '8px',
    fontSize: '0.9rem',
  },
  closeButtonContainer: {
    position: 'absolute',
    bottom: 16,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10001,
  },
  closeButton: {
    opacity: 0,
    transition: 'opacity 0.3s',
    backgroundColor: COLORS.TOOLS_LIGHT_BLUE,
    '&:hover': {
      backgroundColor: COLORS.TOOLS_LIGHT_BLUE,
      opacity: 0.9,
    },
  },
  closeIcon: {
    color: colors.red.A400,
    fontSize: '2rem',
  },
  zoomPreview: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    maxHeight: '90vh',
    objectFit: 'fill',
    borderRadius: '8px',
    filter: 'contrast(1.1)',
    zIndex: 10000,
  },
  zoomCameraPreview: {
    '& video': {
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: 0,
    },
    '& canvas': {
      position: 'fixed',
      top: 0,
    },
  },
  fullScreenImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    objectFit: 'cover',
    zIndex: 10001,
  },
});
